/**
 * Analytics Client — трекинг событий для воронки
 * Используется на страницах товаров, корзины, оформления заказа
 */
import { trackEvent } from './analyticsV1';

let sessionId = null;

function getSessionId() {
  if (!sessionId) {
    sessionId = sessionStorage.getItem('analytics_session');
    if (!sessionId) {
      sessionId = `s_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
      sessionStorage.setItem('analytics_session', sessionId);
    }
  }
  return sessionId;
}

function getUserId() {
  try {
    const token = localStorage.getItem('authToken') || localStorage.getItem('token');
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.sub || payload.id || null;
  } catch {
    return null;
  }
}

/**
 * Трекинг просмотра товара
 */
export function trackProductView(productId, metadata = {}) {
  trackEvent({
    event_type: 'product_view',
    product_id: productId,
    user_id: getUserId(),
    session_id: getSessionId(),
    metadata,
  });
}

/**
 * Трекинг добавления в корзину
 */
export function trackAddToCart(productId, quantity = 1, metadata = {}) {
  trackEvent({
    event_type: 'add_to_cart',
    product_id: productId,
    user_id: getUserId(),
    session_id: getSessionId(),
    metadata: { quantity, ...metadata },
  });
}

/**
 * Трекинг начала оформления заказа
 */
export function trackCheckoutStart(metadata = {}) {
  trackEvent({
    event_type: 'checkout_start',
    user_id: getUserId(),
    session_id: getSessionId(),
    metadata,
  });
}

/**
 * Трекинг завершения заказа
 */
export function trackOrderComplete(orderId, total, metadata = {}) {
  trackEvent({
    event_type: 'order_complete',
    user_id: getUserId(),
    session_id: getSessionId(),
    metadata: { order_id: orderId, total, ...metadata },
  });
}

/**
 * Трекинг поиска
 */
export function trackSearch(query, resultsCount = 0) {
  trackEvent({
    event_type: 'search',
    user_id: getUserId(),
    session_id: getSessionId(),
    metadata: { query, results_count: resultsCount },
  });
}

const analyticsClient = {
  trackProductView,
  trackAddToCart,
  trackCheckoutStart,
  trackOrderComplete,
  trackSearch,
};

export default analyticsClient;
